module.exports = __webpack_public_path__ + "img/dirty-bird_sans.2b8b9737.png";